import moment from 'moment';

import { setError, setSuccessMessage } from '../App/ErrorsActions';
import customFieldsUtils from '../../util/customFieldsUtils';
import downloadFile from '../../util/download';
import { trackDashboardExport } from '../../util/mixpanel';
import CalculationsWorker from '../../services/worker';
import ValuesService from '../../services/values.service';

export const LOADING = 'EXPORTING_LOADING';
export const SUCCESS = 'EXPORTING_SUCCESS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success() {
  return {
    type: SUCCESS
  };
}

export function exportCsv() {
  return async (dispatch, getState) => {
    dispatch(setSuccessMessage('Exporting CSV file'));

    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { user } = getState().auth;
    const filters = getState().filters;

    const valueService = new ValuesService(selected, data);
    const lists = valueService.GetDefaultFilterLists();

    const customFields = customFieldsUtils.getAll(filters.allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, undefined, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableUnmappedListsActivities: user.config.enableUnmappedListsActivities,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });

    try {
      const data = await worker.ExportCsv({
        lists: _.map(lists.all, l => l.value),
        members: _.map(filters.allMembers, m => m.value),
        labels: _.map(filters.allLabels, l => l.value),
        customFields,
        from: filters.dates.startDate.toISOString(),
        to: filters.dates.endDate.toISOString(),
        dateFormat: filters.dateFormat,
        timePrecision: filters.timePrecision,
        excludeWeekendOpts: {
          type: filters.excludeWeekends,
          workStart: filters.workStart,
          workEnd: filters.workEnd,
          holidays: filters.holidays
        }
      });

      const filename = `csv_${moment(filters.dates.startDate).format('YYYY-M-D')}_${moment(
        filters.dates.endDate
      ).format('YYYY-M-D')}.csv`;
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      downloadFile(url, filename);
      
      trackDashboardExport('csv');

      dispatch(success());
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
